export default function CBTExercise({ exercise }) {
  if (!exercise) return null;

  return (
    <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl shadow-lg p-6 border-2 border-indigo-200 animate-fadeIn">
      <div className="flex items-start gap-3 mb-4">
        <span className="text-3xl">🧠</span>
        <div>
          <h3 className="text-xl font-bold text-indigo-900">Quick Mind Shift</h3>
          <p className="text-sm text-indigo-700">A 2-minute exercise to reframe your thoughts</p>
        </div>
      </div>

      <div className="space-y-4">
        {/* Original Thought */}
        <div className="bg-white rounded-lg p-4 border-l-4 border-red-400">
          <p className="text-xs font-semibold text-red-700 mb-1">What you might be thinking:</p>
          <p className="text-gray-700 italic">"{exercise.original_thought}"</p>
        </div>

        {/* Reframed Thought */}
        <div className="bg-white rounded-lg p-4 border-l-4 border-green-400">
          <p className="text-xs font-semibold text-green-700 mb-1">A kinder way to see it:</p>
          <p className="text-gray-700">"{exercise.reframed}"</p>
        </div>

        {/* Action Step */}
        <div className="bg-indigo-100 rounded-lg p-4 border-l-4 border-indigo-500">
          <p className="text-xs font-semibold text-indigo-900 mb-1">⏱️ Try this (2 minutes):</p>
          <p className="text-indigo-900">{exercise.action}</p>
        </div>

        {/* Encouragement */}
        <div className="bg-gradient-to-r from-purple-100 to-pink-100 rounded-lg p-4">
          <p className="text-sm text-purple-900">
            💜 You're doing the work. That matters. Even small shifts count.
          </p>
        </div>
      </div>
    </div>
  );
}
